import React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { AuthProvider } from './AuthProvider';
import { ConfigProvider } from './ConfigProvider';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: false,
			refetchOnWindowFocus: true,
		},
	},
});

export const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<QueryClientProvider client={queryClient}>
			<ReactQueryDevtools />
			<ConfigProvider>
				<AuthProvider>{children}</AuthProvider>
			</ConfigProvider>
		</QueryClientProvider>
	);
};
